export default __webpack_public_path__ + "static/media/Frame 3213mob.ff982020.png";